import styled from "styled-components";
import LoginBg from "../../assets/images/login-bg.png";
// import { styled } from '@mui/material/styles';

const Container = styled.div`
  padding: 163px clamp(20px, 3.95vw, 76px) 60px;
  min-height: 100vh;
  background-image: url(${LoginBg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .logo {
    position: absolute;
    top: clamp(20px, 3.1vw, 60px);
  }
  /* form {
    max-width: 327px;
  } */
  .btn {
    height: 50px;
    width: 100%;
    margin: 15px 0;
  }
  .bottom-span {
    color: var(--text-link);
    line-height: 21px;
    font-size: 14px;
    justify-self: flex-end;
    margin-top: 7px;
    padding-bottom: 2px;
    cursor: pointer;
    position: relative;
    border-bottom: 1px solid var(--text-link);
    /* :after {
      content: "";
      width: 100%;
      height: 1px;
      background-color: var(--text-link);
      display: inline-block;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    } */
  }
`;
const PageTitle = styled.h2`
  color: var(--text-primary);
  font-size: 32px;
  line-height: 38px;
  font-family: "latobold";
  margin-bottom: 43px;
`;
const InputBoxWrapper = styled.div`
  display: grid;
  margin-bottom: 7px;
  position: relative;
  p {
    margin-bottom: 8px;
  }
  input {
    padding: 0 12px;
    min-height: 48px;
    background: #ffffff;
    border: 0.8px solid #1d1d1d;
    border-radius: 4px;
  }
`;
const Wrapper = styled.div`
  /* padding: 0 clamp(20px, 2.9vw, 56px); */
  .MuiFormControlLabel-root {
    margin: 0;
  }
  padding: 43px 56px 53px;
  margin-bottom: 40px;
  max-width: 440px;
  width: 100%;
  background: #ffffffcc;
  border-radius: 10px;
  /* @media (max-width: 550px) {
    backdrop-filter: blur(4px);
  } */
`;

const ActionWrapper = styled.div`
  position: relative;
`;
export { Container, PageTitle, InputBoxWrapper, Wrapper, ActionWrapper };
